import CryptoJS from 'crypto-js';

export const encrypt = (text) => {
  if (!text) {
    throw new Error('No text to encrypt');
  }

  if (!process.env.REACT_APP_ENCRYPTION_KEY) {
    throw new Error('Encryption key not configured');
  }

  const key = process.env.REACT_APP_ENCRYPTION_KEY.trim();
  return CryptoJS.AES.encrypt(text, key).toString();
};

// Returns a time-based HMAC token that rotates every 30 seconds.
// The secret is never transmitted — only the derived token is sent.
export const getServiceToken = () => {
  const secret = process.env.REACT_APP_SERVICE_KEY;
  if (!secret) throw new Error('Service secret not configured');
  const window = Math.floor(Date.now() / 30000);
  return CryptoJS.HmacSHA256(String(window), secret).toString();
};

export const encryptCredentials = (token, serviceName, serviceKey) => {
    const credentials = { token, serviceName, serviceKey, timestamp: Date.now() };
    return encrypt(JSON.stringify(credentials));
};